<template>
  <iframe :src="src" style="height:100%;width:100%"></iframe>
</template>

<script>
export default {
    props:{
        src:{
            default:'',
            type:String,
        }
    }
}
</script>

<style>

</style>